


import { createSlice } from "@reduxjs/toolkit";
import { getJobSite } from "../reduxApi/jobSiteReduxApi";

const jobSiteSlice = createSlice({
    name: 'jobsite',
    initialState: {
        status: 'idel',
        jobsite: [],
    },
    reducers: {
        deletejobsiteAction: (state, action) => {
            action.payload.forEach((ROWID) => {
                const index = state.jobsite.findIndex((item) => item.ROWID === ROWID);
                if (index !== -1) {
                    state.jobsite.splice(index, 1);
                }
            });
        },
        updatejobsiteAction: (state, action) => {
            console.log("action", action.payload.ROWID)
            const index = state.jobsite.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.jobsite.splice(index, 1, action.payload)
    
            }
        },
        addjobsiteAction: (state, action) => {
            console.log("Adding jobsite:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.jobsite.unshift(temp);
        },
        addtaskAction: (state, action) => {
            console.log("Adding jobtask:", action.payload);
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.jobsite.unshift(temp);
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getJobSite.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getJobSite.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing jobsite Data", action.payload)
                state.jobsite = action.payload.data.jobsiteResp
;
            })
    }
})
export const { deletejobsiteAction, updatejobsiteAction, addjobsiteAction,addtaskAction} = jobSiteSlice.actions
export default jobSiteSlice.reducer




// import { createSlice } from "@reduxjs/toolkit";
// import { getJobSite } from "../reduxApi/jobSiteReduxApi";

// const jobSiteSlice = createSlice({
//     name: 'jobsite',
//     initialState: {
//         status: 'idel',
//         jobsite: [],
//     },
//     reducers: {
//         deletejobsiteAction: (state, action) => {
//             action.payload.forEach((ROWID) => {
//                 const index = state.jobsite.findIndex((item) => item.ROWID === ROWID);
//                 if (index !== -1) {
//                     state.jobsite.splice(index, 1);
//                 }
//             });
//         },
//         updatejobsiteAction: (state, action) => {
//             console.log("action", action.payload.ROWID)
//             const index = state.jobsite.findIndex((item) => item.ROWID === action.payload.ROWID)
//             if (index != -1) {
//                 state.jobsite.splice(index, 1, action.payload)
    
//             }
//         },
//         addjobsiteAction: (state, action) => {
//             console.log("Adding jobsite:", action.payload);
//             const temp = action.payload.formData;
//             temp.ROWID = action.payload.ROWID;
//             state.jobsite.unshift(temp);
//         }
//     },
//     extraReducers: (builder) => {
//         builder.addCase(getJobSite.pending, (state, action) => {
//             state.status = 'pending'
//         })
//             .addCase(getJobSite.fulfilled, (state, action) => {
//                 state.status = 'fulfilled'
//                 console.log("testing jobsite Data", action.payload)
//                 state.jobsite = action.payload.data.jobsiteResp
// ;
//             })
//     }
// })
// export const { deletejobsiteAction, updatejobsiteAction, addjobsiteAction } = jobSiteSlice.actions
// export default jobSiteSlice.reducer